module.exports = __webpack_public_path__ + "static/media/btnupload.051a875c.svg";